import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { ButtonProps } from './ButtonProps';

export const Button: FunctionComponent<ButtonProps> = ({ className, title, icon, tooltip, onClick }) => {
  return (
    <button className={classNames('text-tint hover-effect click-effect', className)} title={tooltip} onClick={onClick}>
      <div className="h-stack items-center space-x-1">
        {icon ? <img className="w-5 h-5" src={icon} alt="" /> : undefined}
        <div>{title}</div>
      </div>
    </button>
  );
};
